import { ActionCreator } from 'redux';
import { ValidEmail } from '@dev/ee-api/ee-api-models';
import { ApplicationState } from '@/store';
import {
    ValidEmailsFetchStartAction,
    ValidEmailsFetchSuccessAction,
    ValidEmailsFetchErrorAction,
    ResendEmailVerificationAction,
    DeleteValidEmailAction,
    DeleteValidEmailSuccessAction,
    DeleteValidEmailErrorAction,
    AddValidEmailAction,
    AddValidEmailSuccessAction,
    AddValidEmailErrorAction,
    AddSingleEmailViewAction,
    DeleteSingleEmailViewAction,
    ValidEmailsActionTypes,
    ValidEmailsState,
    AddValidEmailErrorMessage,
} from './types';

export const LoadValidEmails: ActionCreator<ValidEmailsFetchStartAction> = (): ValidEmailsFetchStartAction => ({
    type: ValidEmailsActionTypes.VALIDEMAILS_FETCH_START,
});
export const LoadValidEmailsSuccess: ActionCreator<ValidEmailsFetchSuccessAction> = (
    emails: ValidEmail[]
): ValidEmailsFetchSuccessAction => ({
    type: ValidEmailsActionTypes.VALIDEMAILS_FETCH_SUCCESS,
    payload: {
        emails,
    },
});
export const LoadValidEmailsError: ActionCreator<ValidEmailsFetchErrorAction> = (): ValidEmailsFetchErrorAction => ({
    type: ValidEmailsActionTypes.VALIDEMAILS_FETCH_ERROR,
});
export const ResendEmailVerification: ActionCreator<ResendEmailVerificationAction> = (
    email: string
): ResendEmailVerificationAction => ({
    type: ValidEmailsActionTypes.VALIDEMAILS_RESEND_VERIFICATION,
    payload: {
        email,
    },
});
export const DeleteValidEmail: ActionCreator<DeleteValidEmailAction> = (email: string[]): DeleteValidEmailAction => ({
    type: ValidEmailsActionTypes.VALIDEMAILS_DELETE,
    payload: {
        email,
    },
});
export const DeleteValidEmailSuccess: ActionCreator<DeleteValidEmailSuccessAction> = (
    emails: ValidEmail[]
): DeleteValidEmailSuccessAction => ({
    type: ValidEmailsActionTypes.VALIDEMAILS_DELETE_SUCCESS,
    payload: {
        emails,
    },
});
export const DeleteValidEmailError: ActionCreator<DeleteValidEmailErrorAction> = (): DeleteValidEmailErrorAction => ({
    type: ValidEmailsActionTypes.VALIDEMAILS_DELETE_ERROR,
});
export const AddValidEmail: ActionCreator<AddValidEmailAction> = (email: string): AddValidEmailAction => ({
    type: ValidEmailsActionTypes.VALIDEMAILS_ADD,
    payload: {
        email,
    },
    meta: {
        thunk: true,
    },
});
export const AddValidEmailsSuccess: ActionCreator<AddValidEmailSuccessAction> = (
    emails: ValidEmail[],
    meta
): AddValidEmailSuccessAction => ({
    type: ValidEmailsActionTypes.VALIDEMAILS_ADD_SUCCESS,
    payload: {
        emails,
    },
    meta,
});
export const AddValidEmailError = (
    error: AddValidEmailErrorMessage,
    meta: Record<string, unknown>
): AddValidEmailErrorAction => ({
    type: ValidEmailsActionTypes.VALIDEMAILS_ADD_ERROR,
    payload: error,
    meta,
    error: true,
});
export const AddValidEmailSingleView: ActionCreator<AddSingleEmailViewAction> = (
    email: string
): AddSingleEmailViewAction => ({
    type: ValidEmailsActionTypes.VALIDEMAILS_SINGLE_VIEW,
    payload: {
        email,
    },
});
export const DeleteValidEmailSingleView: ActionCreator<
    DeleteSingleEmailViewAction
> = (): DeleteSingleEmailViewAction => ({
    type: ValidEmailsActionTypes.VALIDEMAILS_SINGLE_VIEW_DELETE,
    payload: {
        email: null,
    },
});

export const getValidEmailsStore = (state: ApplicationState): ValidEmailsState => state.validEmails;
